import { CompanyDetails } from '@/components/company-details';
import { useCompanyContext } from '@/components/company-shell';

/**
 * Page `/company/:companyId` (index child of `CompanyShellPage`) —
 * "Empresa" tab. Reads the loaded company from the shell's outlet
 * context and renders the read-only dashboard.
 */
export const CompanyDetailsPage = () => {
  const { company, refetch } = useCompanyContext();

  return <CompanyDetails company={company} refetch={refetch} />;
};
